export const environment = {
    logLevel: 'debug',
    production: false,
    apiUrl: 'https://apim-br.devtest.aws.scania.com/rena-acp/1.0/api/',
    envFlag: 'TEST',
    authUrl: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
    authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
    clientId: '0bf140d1-7bcb-4ced-b6e8-4ddde46a07b4',
    apiScope: 'api://0bf140d1-7bcb-4ced-b6e8-4ddde46a07b4/.default',
    redirectUri: 'https://rena.test.sla-salesforce.devtest.gf.aws.scania.com/Home'
};